/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  zones: { data: [], meta: {} },
  page: 1,
};

const getters = {
  zones: state => state.zones,
  page: state => state.page,
};

const actions = {
  fetchAll({ commit }, payload) {
    let keyword = '';
    if (payload.keyword) {
      keyword = `&q=${payload.keyword.replace(/[^a-zA-Z0-9]/g, '')}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/zones/list?${keyword}`)
      .then(response => response.data)
      .then((data) => {
        commit(mTypes.DATA_FETCHED, data);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch zones');
      });
  },
  fetch({ commit }, payload) {
    const page = `&page=${state.page}`;
    let keyword = '';
    if (payload.keyword) {
      keyword = `&q=${payload.keyword.replace(/[^a-zA-Z0-9]/g, '')}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/zones/list?${keyword}${page}`)
      .then(response => response.data)
      .then((data) => {
        if (payload.updateResults) {
          return commit(mTypes.DATA_UPDATED, data);
        }
        return commit(mTypes.DATA_FETCHED, data);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch zones');
      });
  },
  autocomplete({ commit }, payload) {
    commit(mTypes.SET_PAGE, 1);
    const page = `&page=${state.page}`;
    let keyword = '';
    if (payload.keyword) {
      keyword = `&q=${payload.keyword.replace(/[^a-zA-Z0-9]/g, '')}`;
    }
    return Vue.http.get(`${getApiPath(payload.user)}/zones/list?${keyword}${page}`)
      .then(response => response.data)
      .then((data) => {
        commit(mTypes.DATA_FETCHED, data);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch zones');
      });
  },
  list({ commit }, payload) {
    // TODO: filter, limit has to be like this for now
    return Vue.http.get(`${getApiPath(payload.user)}/zones/list`)
      .then(response => response.data)
      .then((data) => {
        commit(mTypes.DATA_FETCHED, data);
      })
      .catch((error) => {
        console.log(error, 'failed to fetch zones');
      });
  },
};

const mutations = {
  [mTypes.EDIT_DATA](state, updatedZone) {
    const index = state.zones.data.findIndex(obj => obj.id === updatedZone.id);
    if (index !== -1) {
      state.zones.data[index].address = updatedZone.address;
      state.zones.data[index].code = updatedZone.code;
    } else {
      state.zones.data.unshift(updatedZone);
      state.zones.meta.total += 1;
    }
  },
  [mTypes.DATA_FETCHED](state, zones) {
    state.zones.data = zones.data;
    state.zones.meta = zones.meta;
  },
  [mTypes.DATA_UPDATED](state, zones) {
    state.zones.data.push(...zones.data);
    state.zones.meta = zones.meta;
  },
  [mTypes.SET_PAGE](state, page) {
    state.page = page;
  },
  [mTypes.REMOVE_DATA](state, zoneId) {
    const index = state.zones.data.findIndex(obj => obj.id === zoneId);
    state.zones.data.splice(index, 1);
    state.zones.meta.total -= 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/landlord/zones.js